import Apis from 'apis';
import { objToQueryString } from 'utils/helpers';

export const api = Apis({});

interface QueryProps {
  limit?: number | string;
  offset?: number | string;
  search?: string;
}

export default {
  newOperator: () => '/operator/',
  updateOperator: () => '/operator/permissions/',
  resetMFAOperator: (operatorUuid: string) =>
    `/operator/${operatorUuid}/reset-mfa/`,
  enableOrDisableMFA: (operatorUuid: string) =>
    `/operator/${operatorUuid}/switch-mfa/`,
  removeOperator: (id: string) => `/operator/${id}/`,
  editOperator: (id: string) => `/operator/${id}/`,
  getOperator: (id: string) => `/operator/${id}/`,
  resetPasswordOperator: () => '/authenticate/password/reset/',
  getAllOperators: (query: QueryProps) =>
    `/operator/?${objToQueryString(query)}`,

  getOperatorTokens: (operatorUuid: string, query: string) =>
    `/operator/${operatorUuid}/token/?${objToQueryString(query)}`,
  newOperatorToken: (operatorUuid: string) =>
    `/operator/${operatorUuid}/token/`,
  operatorToken: (operatorUuid: string, tokenUuid: string) =>
    `/operator/${operatorUuid}/token/${tokenUuid}/`,
  operatorRole: (
    operatorUuid: string,
    showAllRoles: boolean,
    query: QueryProps
  ) =>
    `/operator/${operatorUuid}/role/?show_all_roles=${showAllRoles}&${objToQueryString(
      query
    )}`,
};
